<app-menu></app-menu>

<div style="background-color: #ffffff;">
    <div class="fundo-cloud-hero uk-light">
        <div class="uk-container uk-text-center">
            <h1 class="hero-standard-title" uk-scrollspy="cls: uk-animation-slide-top-small; delay: 100">
                Cloud Computing
            </h1>
            <p class="uk-text-large" style="opacity: 0.9;" uk-scrollspy="cls: uk-animation-slide-bottom-small; delay: 300">
                Alta disponibilidade, escalabilidade e conectividade para o seu negócio.
            </p>
        </div>
    </div>
</div>

<div class="uk-padding uk-section-muted">
    <div class="uk-container">

    
    <div class="uk-grid uk-margin-large-left uk-margin-large-right uk-child-width-1-1 uk-text-center uk-grid-match" uk-grid>
   
        <div >
            <div class="uk-grid uk-child-width-1-3 uk-text-center uk-grid-match" uk-grid>
                <div>
                    <div class="border uk-card uk-card-secondary uk-card-body ">
                        <h3 style="font-weight: bold;" >Criar uma  <br> Máquina Virtual</h3>

                        <img src="img/sistemas.png">
                        <form class="uk-form-stacked">

                            <div class="uk-margin">
                                <label class="uk-form-label" for="form-stacked-text">Nome da Máquina</label>
                                <div class="uk-form-controls">
                                    <input class="uk-input uk-border-rounded uk-text-center" id="form-stacked-text" type="text" placeholder="">
                                </div>
                            </div>
                        
                            <div class="uk-margin">
                                <label class="uk-form-label" for="form-stacked-select">Escolha o Sistema Operacional</label>
                                <div class="uk-form-controls">
                                    <select class="uk-select uk-border-rounded uk-text-center" id="form-stacked-select">
                                        <option>Linux - Debian</option>
                                        <option>Linux - Ubuntu</option>
                                        <option>Windows Server</option>
                                    </select>
                                </div>
                            </div>
                        
                            <div class="uk-margin uk-light">
                                <div class="uk-form-label uk-border-rounded">CPU, RAM & SSD</div>
                                <div class="uk-form-controls">
                                    <label class="uk-border-rounded"><input class="uk-border-pill uk-radio" type="radio" name="radio1"> 2vCPU | 2GB RAM | 25 GB </label><br>
                                    <label class="uk-border-rounded"><input class="uk-border-pill uk-radio" type="radio" name="radio1"> 4vCPU | 4GB RAM | 50 GB </label><br>
                                    <label class="uk-border-rounded"><input class="uk-border-pill uk-radio" type="radio" name="radio1"> 4vCPU | 8GB RAM | 100 GB </label><br>

                                </div>
                            </div>
                        
                        </form>
                        <button class="uk-margin-small-top uk-button uk-button-primary uk-border-pill">Pagar</button>

                    </div>
                </div>
                <div>
                    <div class="border uk-card uk-card-secondary uk-card-body uk-text-center">
                        <h3 style="font-weight: bold;" >Criar uma conta <br> de armazenamento</h3>

                        <img src="img/armazenamento.png">
                        <form class="uk-form-stacked">

                            <div class="uk-margin">
                                <label class="uk-form-label" for="form-stacked-text">Domínio</label>
                                <div class="uk-form-controls">
                                    <input class="uk-input uk-border-rounded uk-text-center" id="form-stacked-text" type="text" placeholder="">
                                </div>
                            </div>
                        
                            <div class="uk-margin">
                                <label class="uk-form-label" for="form-stacked-select">Tipo de Armazenamento</label>
                                <div class="uk-form-controls ">
                                    <select class="uk-select uk-border-rounded uk-text-center" id="form-stacked-select">
                                        <option>Object Storage</option>
                                        <option>Block Storage</option>
                                    </select>
                                </div>
                            </div>
                        
                            <div class="uk-margin uk-light">
                                <div class="uk-form-label uk-border-rounded">Espaço em SSD</div>
                                <div class="uk-form-controls uk-text-center">
                                    <label class="uk-border-rounded"><input class="uk-border-pill uk-radio" type="radio" name="radio1"> 25 GB</label><br>
                                    <label><input class="uk-radio" type="radio" name="radio1"> 50GB</label><br>
                                    <label><input class="uk-radio" type="radio" name="radio1"> Ilimitado</label>

                                </div>
                            </div>
                        
                        </form>
                        <button class="uk-margin-small-top uk-button uk-button-primary uk-border-pill">Pagar</button>

                    </div>
                </div>
                <div>
                    <div class="border uk-card uk-card-secondary uk-card-body ">
                        <h3 style="font-weight: bold;" >Hospedar uma <br> base de dados</h3>

                        <img src="img/dbaas.png">
                        <form class="uk-form-stacked">

                            <div class="uk-margin">
                                <label class="uk-form-label" for="form-stacked-text">Hostname</label>
                                <div class="uk-form-controls">
                                    <input class="uk-input uk-border-rounded uk-text-center" id="form-stacked-text" type="text" placeholder="">
                                </div>
                            </div>
                        
                            <div class="uk-margin">
                                <label class="uk-form-label" for="form-stacked-select">Modelo</label>
                                <div class="uk-form-controls">
                                    <select class="uk-select uk-border-rounded uk-text-center" id="form-stacked-select">
                                        <option>MySQL Server</option>
                                        <option>MariaDB</option>
                                        <option>PostgreSQL</option>

                                    </select>
                                </div>
                            </div>
                        
                            <div class="uk-margin uk-light">
                                <div class="uk-form-label uk-border-rounded">Espaço</div>
                                <div class="uk-form-controls uk-text-center">
                                    <label class="uk-border-rounded"><input class="uk-border-pill uk-radio" type="radio" name="radio1"> 10 GB</label><br>
                                    <label><input class="uk-radio" type="radio" name="radio1"> 50 GB</label><br>
                                    <label><input class="uk-radio" type="radio" name="radio1">Ilimitado</label>

                                </div>
                            </div>
                        
                        </form>
                        <button class="uk-margin-small-top uk-button uk-button-primary uk-border-pill">Pagar</button>

                    </div>
                </div>
                </div>
        </div>
    
     
    </div>



</div>




